export default class MonitoramentoAlteracoes {
  constructor(
    ncm = "",
    descricao,
    categoria,
    data,
    hora,
    observacaoConsultor,
    aliquota
  ) {
    this.ncm = ncm;
    this.descricao = descricao;
    this.categoria = categoria;
    this.data = data;
    this.hora = hora;
    this.observacaoConsultor = observacaoConsultor;
    this.aliquota = aliquota;
    this.toggle = false;
  }
}
